import React from 'react'
import { FiArrowRight } from '@react-icons/all-files/fi/FiArrowRight'
import { FiCheckCircle } from '@react-icons/all-files/fi/FiCheckCircle'
import { helper } from '../../../utilities/helper'
import { formatPortfolioDate, getEventType } from '../../../utilities/portfolioPresentation'
import Action from '../primitives/Action'
import Media from '../primitives/Media'
import { MEDIA_POLICY_KEYS } from '../primitives/mediaPolicy'
import styles from './ProductPortfolioProof.module.scss'

const ProductPortfolioProof = ({ event, onView }) => {
  if (!event?._id || !event?.title) return null

  const eventUrl = `/portfolio/${helper.makeUrl(event.title)}`
  const summary = helper.shortText(event.main_paragraph || event.subtitle, 30)

  return (
    <section className={styles.proof} aria-labelledby='product-portfolio-proof-heading' data-msr-product-proof>
      <Media
        picture={event.pictures?.[0]}
        alt={`${event.title} event production by Miami Sound Rental`}
        policy={MEDIA_POLICY_KEYS.SECTION_SPLIT}
        ratio='16 / 10'
        className={styles.media}
      />

      <div className={styles.content}>
        <span className={styles.eyebrow}>Real-event proof</span>
        <h2 id='product-portfolio-proof-heading'>See this equipment in a real production</h2>
        <div className={styles.eventMeta}>
          <span>{getEventType(event)}</span>
          {event.date && <time dateTime={event.date}>{formatPortfolioDate(event.date)}</time>}
        </div>
        <h3>{event.title}</h3>
        {summary && <p>{summary}</p>}
        <span className={styles.verification}>
          <FiCheckCircle aria-hidden='true' /> Verified from the event&apos;s recorded equipment list
        </span>
        <Action
          href={eventUrl}
          variant='outline'
          className={styles.action}
          ariaLabel={`View the ${event.title} production case study`}
          onClick={() => onView?.(event)}
          dataAction='product-portfolio-proof'
        >
          View the production case study <FiArrowRight aria-hidden='true' />
        </Action>
      </div>
    </section>
  )
}

export default ProductPortfolioProof
